<template>
  <div class="contact-container">
    <app-navbar8 logoSrc="/logo_trans-1500h.png">
      <template v-slot:link1>
        <div class="contact-fragment10">
          <span class="contact-text10">#home</span>
        </div>
      </template>
      <template v-slot:link2>
        <div class="contact-fragment11">
          <span class="contact-text11">#products</span>
        </div>
      </template>
      <template v-slot:link3>
        <div class="contact-fragment12">
          <span class="contact-text12">#services</span>
        </div>
      </template>
      <template v-slot:link4>
        <div class="contact-fragment13">
          <span class="contact-text13">#contact</span>
        </div>
      </template>
      <template v-slot:page1>
        <div class="contact-fragment14">
          <span class="contact-text14">Home</span>
        </div>
      </template>
      <template v-slot:page2>
        <div class="contact-fragment15">
          <span class="contact-text15">Products</span>
        </div>
      </template>
      <template v-slot:page3>
        <div class="contact-fragment16">
          <span class="contact-text16">Services</span>
        </div>
      </template>
      <template v-slot:page4>
        <div class="contact-fragment17">
          <span class="contact-text17">Contact</span>
        </div>
      </template>
      <template v-slot:action1>
        <div class="contact-fragment18">
          <span class="contact-text18">Sign In</span>
        </div>
      </template>
      <template v-slot:action2>
        <div class="contact-fragment19">
          <span class="contact-text19">Create</span>
        </div>
      </template>
      <template v-slot:page1Description>
        <div class="contact-fragment20">
          <span class="contact-text20">Page One Description</span>
        </div>
      </template>
      <template v-slot:page2Description>
        <div class="contact-fragment21">
          <span class="contact-text21">Page Two Description</span>
        </div>
      </template>
      <template v-slot:page3Description>
        <div class="contact-fragment22">
          <span class="contact-text22">Page Three Description</span>
        </div>
      </template>
      <template v-slot:page4Description>
        <div class="contact-fragment23">
          <span class="contact-text23">Page Four Description</span>
        </div>
      </template>
    </app-navbar8>
    <contact-form7>
      <template v-slot:email>
        <div class="contact-fragment24">
          <span class="contact-text24">info@wildwoodherbs.com</span>
        </div>
      </template>
      <template v-slot:phone>
        <div class="contact-fragment25">
          <span class="contact-text25">+1-555-555-5555</span>
        </div>
      </template>
      <template v-slot:action>
        <div class="contact-fragment26">
          <span class="contact-text26">Contact us</span>
        </div>
      </template>
      <template v-slot:address>
        <div class="contact-fragment27">
          <span class="contact-text27">Stllwater, MN</span>
        </div>
      </template>
      <template v-slot:content1>
        <div class="contact-fragment28">
          <span class="contact-text28">
            Have a question or need more information?
          </span>
        </div>
      </template>
      <template v-slot:heading1>
        <div class="contact-fragment29">
          <span class="contact-text29">Get in Touch</span>
        </div>
      </template>
    </contact-form7>
    <app-footer4>
      <template v-slot:termsLink>
        <div class="contact-fragment30">
          <span class="contact-text30">Terms of Service</span>
        </div>
      </template>
      <template v-slot:cookiesLink>
        <div class="contact-fragment31">
          <span class="contact-text31">Cookies Settings</span>
        </div>
      </template>
      <template v-slot:privacyLink>
        <div class="contact-fragment32">
          <span class="contact-text32">Privacy Policy</span>
        </div>
      </template>
    </app-footer4>
  </div>
</template>

<script>
import AppNavbar8 from '../components/navbar8'
import ContactForm7 from '../components/contact-form7'
import AppFooter4 from '../components/footer4'

export default {
  name: 'Contact',
  props: {},
  components: {
    AppNavbar8,
    ContactForm7,
    AppFooter4,
  },
  metaInfo: {
    title: 'Contact - Wildwood Herbs',
    meta: [
      {
        property: 'og:title',
        content: 'Contact - Wildwood Herbs',
      },
    ],
  },
}
</script>

<style scoped>
.contact-container {
  width: 100%;
  display: flex;
  min-height: 100vh;
  align-items: center;
  flex-direction: column;
}
 
.contact-fragment10 {
  display: contents;
}
 
.contact-text10 {
  display: inline-block;
}
 
.contact-fragment11 {
  display: contents;
}
 
.contact-text11 {
  display: inline-block;
}
 
.contact-fragment12 {
  display: contents;
}
 
.contact-text12 {
  display: inline-block;
}
 
.contact-fragment13 {
  display: contents;
}
 
.contact-text13 {
  display: inline-block;
}
 
.contact-fragment14 {
  display: contents;
}
 
.contact-text14 {
  display: inline-block;
}
 
.contact-fragment15 {
  display: contents;
}
 
.contact-text15 {
  display: inline-block;
}
 
.contact-fragment16 {
  display: contents;
}
 
.contact-text16 {
  display: inline-block;
}
 
.contact-fragment17 {
  display: contents;
}
 
.contact-text17 {
  display: inline-block;
}
 
.contact-fragment18 {
  display: contents;
}
 
.contact-text18 {
  display: inline-block;
}
 
.contact-fragment19 {
  display: contents;
}
 
.contact-text19 {
  display: inline-block;
}
 
.contact-fragment20 {
  display: contents;
}
 
.contact-text20 {
  display: inline-block;
}
 
.contact-fragment21 {
  display: contents;
}
 
.contact-text21 {
  display: inline-block;
}
 
.contact-fragment22 {
  display: contents;
}
 
.contact-text22 {
  display: inline-block;
}
 
.contact-fragment23 {
  display: contents;
}
 
.contact-text23 {
  display: inline-block;
}
 
.contact-fragment24 {
  display: contents;
}
 
.contact-text24 {
  display: inline-block;
}
 
.contact-fragment25 {
  display: contents;
}
 
.contact-text25 {
  display: inline-block;
}
 
.contact-fragment26 {
  display: contents;
}
 
.contact-text26 {
  display: inline-block;
}
 
.contact-fragment27 {
  display: contents;
}
 
.contact-text27 {
  display: inline-block;
}
 
.contact-fragment28 {
  display: contents;
}
 
.contact-text28 {
  display: inline-block;
}
 
.contact-fragment29 {
  display: contents;
}
 
.contact-text29 {
  display: inline-block;
}
 
.contact-fragment30 {
  display: contents;
}
 
.contact-text30 {
  display: inline-block;
}
 
.contact-fragment31 {
  display: contents;
}
 
.contact-text31 {
  display: inline-block;
}
 
.contact-fragment32 {
  display: contents;
}
 
.contact-text32 {
  display: inline-block;
}
</style>
